<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <strong>Tipo</strong>
                    <v-select  v-model="type" :options="types">
                        <option value="ZVI2">Producto Terminado (ZVI2)</option>
                        <option value="ZMGB">Guarda Botella (ZMGB)</option>                      
                    </v-select>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                <input type="file" id="file-massive-activated-masteritems" required/>
            </div>
        </div>     
        <div class="row mt-4">       
            <div class="col-md-12">
                <button @click="upload" class="btn btn-block btn-success">
                    <i class="fa fa-save"></i>
                    Procesar
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { Put } from "../../helper/axios.js";

export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Put,
            type: '',
            types: [
                { label: 'Producto Terminado (ZVI2)', value: 'ZVI2' },
                { label: 'Guarda Botella (ZMGB)', value: 'ZMGB' },
                { label: 'Empaques y Embalajes (ZEMP)', value: 'ZEMP' }
            ]
        };
    },
    methods: {
        upload() {
            let formData = new FormData();
            let file = document.getElementById("file-massive-activated-masteritems");

            if (file)
            {
                file = file.files[0];
                formData.append("file", file);
                formData.append("type", this.type.value);
                try {
                    this.$store.commit("setLoading", true);
                    this.Put(`${this.apiUrl}v1/masteritems/massiveActivate`, formData, (res) => {
                        this.$store.commit("setLoading", false);
                        window.toastr.success("Se ha procesa la activación masiva del Maestro de Items correctamente. " + res.data);
                        this.$emit("updateDone", true);
                });
                } catch (error) {
                    alert("Error al procesar el archivo.");
                    console.error(error);
                }
            }
        }
    }
}
</script>